const getEntropy = (password) => {
    let entropy = 0;
    if (!password) {
        return entropy;
    }
    if (password.length < 8) {
        entropy = 1;
    }
    else if (password.length < 10) {
        entropy = 2 + (password.length * 2);
    }
    else {
        const lengthComp = ((password.length - 10) * 1.5).toFixed();
        entropy = 21 + parseInt(lengthComp, 10);
    }
    const variations = {
        digits: /\d/.test(password),
        lower: /[a-z]/.test(password),
        upper: /[A-Z]/.test(password),
        nonWords: /\W/.test(password),
    };
    let variationCount = 0;
    Object.keys(variations).forEach((check) => {
        variationCount += (variations[check] === true) ? 1 : 0;
    });
    if (variationCount === 4) {
        entropy += 18;
    }
    else if (variationCount === 3) {
        entropy += 12;
    }
    else if (variationCount === 2) {
        entropy += 6;
    }
    return entropy;
};
export const getPasswordStrength = (password) => {
    const entropy = parseInt(getEntropy(password).toString(), 10);
    const okayMin = 24;
    const goodMin = 31;
    const greatMin = 40;
    if (entropy >= greatMin) {
        return 'Great!';
    }
    if (entropy < greatMin && entropy >= goodMin) {
        return 'Good';
    }
    if (entropy < goodMin && entropy >= okayMin) {
        return 'Okay';
    }
    if (entropy > 0 && entropy < okayMin) {
        return 'Weak';
    }
    return 'Strength';
};
export const checkPasswordStrength = ({ password, setStrengthText, setStrengthMeterClass }) => {
    const strength = getPasswordStrength(password);
    const strengthMeter = document.getElementById('strength-meter-gauge');
    const strengthText = document.getElementById('strength-text');
    setStrengthText(strength);
    let className;
    if (strength === 'Weak') {
        className = 'weak';
    }
    else if (strength === 'Okay') {
        className = 'okay';
    }
    else if (strength === 'Good') {
        className = 'good';
    }
    else if (strength === 'Great!') {
        className = 'great';
    }
    else if (strength === 'Strength') {
        className = 'strength';
    }
    setStrengthMeterClass(className || '');
    strengthText === null || strengthText === void 0 ? void 0 : strengthText.setAttribute('class', `${className} strength-text`);
    strengthMeter === null || strengthMeter === void 0 ? void 0 : strengthMeter.setAttribute('class', `${className} form-inline strength-meter`);
};
